import { InfoTooltip } from "@/components/design/InfoTooltip";

// Label plus Erklaerung fuer einen Einstellungs-Regler: der Name steht, die Bedeutung der
// einzelnen Optionen sitzt im Tooltip. Aus CandidateAssessmentPromptEditor herausgezogen, als der
// zweite Nutzer dazukam (spark#305) — kopiert waere die naechste Abweichung im Abstand oder in der
// Tooltip-Breite eine Frage der Zeit gewesen.
//
// KEIN design/-Primitive: das ist eine lokale Zusammensetzung aus `smycles-field-label` und InfoTooltip,
// keine neue Rolle im Katalog (UI_CONVENTIONS, "Changing this system").
export function SettingLabel({
  label,
  ariaLabel,
  descriptions,
  className = "mb-1.5",
}: {
  label: string;
  ariaLabel: string;
  descriptions: Array<{ label: string; description: string }>;
  // Layout only. Default keeps the stacked form (Label ueber dem Regler); eine Zeile, die Label
  // und Regler nebeneinander stellt, setzt "mb-0".
  className?: string;
}) {
  return (
    <div className={`flex items-center gap-1 leading-none ${className}`}>
      <span className="smycles-field-label">{label}</span>
      <InfoTooltip
        ariaLabel={ariaLabel}
        title={label}
        contentClassName="w-[20rem] max-w-[calc(100vw-2rem)]"
      >
        <span className="block space-y-1.5">
          {descriptions.map((item) => (
            <span key={item.label} className="block">
              <span className="font-medium">{item.label}:</span> {item.description}
            </span>
          ))}
        </span>
      </InfoTooltip>
    </div>
  );
}
